import React, { useState } from "react";

//UI Material
import {
  Card,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";

import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

//Material Icons
import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import ModalWindow from "../Modal";
import Selector from "../basics/Selector";
import { searchEngine } from "../../Helpers/searchEngine";

export default function RegisteredProductsList({
  data = [],
  getData,
  users = [],
}) {
  //Registers filter by
  const filterBy = ["Todos", "Pendientes", "Probados"];

  // ==========>Component States<==========
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //State for loading
  const [isLoading, setIsLoading] = useState(false);
  //State for open confirm modal
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");
  //State for register status
  const [registerStatus, setRegisterStatus] = useState(1);
  //State for search data by query
  const [searchQuery, setSearchQuery] = useState("");
  //State for productId
  const [productId, setProductId] = useState("");

  // ==========> Component Functions <==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };
  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Function to filter data by status
  const filerRegistersStatus = (status, data) => {
    switch (status) {
      case 0:
        return data;
      case 1:
        return data.filter((i) => !i.testedBy);
      case 2:
        return data.filter((i) => i.testedBy);
      default:
        return data;
    }
  };

  //Function for data query
  const filterData = (query, data) => {
    if (!query) {
      return data;
    } else {
      return searchEngine(data, query);
    }
  };

  //Data in the table
  const dataFiltered = filterData(searchQuery, data);

  // Function to TEST
  const testProduct = async (id) => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/assembly/new-testing",
        {
          id,
          testedTag: "",
        }
      );
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        setModalText("El producto fue probado exitosamente.");
        setModalDescription(`Se ha probado el producto ${id} exitosamente.`);
      } else {
        setModalText("No se pudo registrar el producto probado.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      setModalText("No se pudo realizar la acción.");
      setModalDescription(
        "Error registrar el producto probado, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
    }
    setConfirmModalOpen(false);
    setModalOpen(true);
    setIsLoading(false);
    getData();
  };

  //Function to get user name
  const getUserName = (userEmail) => {
    const user = users.find((user) => user.email === userEmail);
    return user.user;
  };

  // ==========> Component <==========
  return (
    <Card raised>
      <Grid container sx={{ padding: "10px" }} spacing={1}>
        <Grid item xs={12}>
          {typographyForSubtitles("Historial de registros", "secondary")}
        </Grid>
        <Grid item xs={12} align="center" sx={{ marginTop: "10px" }}>
          <TextField
            id="search-bar"
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
            label="Buscar"
            variant="outlined"
            placeholder="Buscar..."
            size="small"
          />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Table aria-label="production-table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Producto",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Encargado",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Etiquetas",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Fecha de ensamblado",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Selector
                      label="Estado"
                      value={registerStatus}
                      handleChange={(e) => {
                        setRegisterStatus(e.target.value);
                        setPage(0);
                      }}
                      content={filterBy}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filerRegistersStatus(registerStatus, dataFiltered)
                  .sort(
                    (a, b) => new Date(b.assemblyAt) - new Date(a.assemblyAt)
                  )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((i) => (
                    <TableRow key={i.id}>
                      <TableCell align="center">{i.productName}</TableCell>
                      <TableCell align="center">
                        {getUserName(i.assemblyBy)}
                      </TableCell>
                      <TableCell align="center">{i.tag}</TableCell>
                      <TableCell align="center">
                        {new Date(i.assemblyAt).toLocaleDateString()}
                      </TableCell>
                      <TableCell align="center">
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          justifyContent="center"
                        >
                          {i.testedBy ? (
                            <RadioButtonChecked color="secondary" />
                          ) : (
                            <IconButton
                              size="small"
                              onClick={() => {
                                setProductId(i.id);
                                setConfirmModalOpen(true);
                              }}
                            >
                              <RadioButtonUnchecked />
                            </IconButton>
                          )}

                          {typographyForText(
                            `  ${
                              i.testedAt
                                ? new Date(i.testedAt).toLocaleDateString()
                                : "Pendiente"
                            }
                          ${
                            i.testedAt
                              ? "por " + getUserName(i.testedBy)
                              : ""
                          }`
                          )}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={filerRegistersStatus(registerStatus, dataFiltered).length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Filas"
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={confirmModalOpen}
        handleClose={() => setConfirmModalOpen(false)}
        title={"Confirmar Pruebas"}
        text={"¿Desea confirmar las pruebas realizadas a este producto?"}
        leftText="OK"
        leftClick={() => {
          testProduct(productId);
        }}
      />
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </Card>
  );
}
